(function () {
  var container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  var path = window.location.pathname.replace(/\/$/, '');

  var navItems = [
    { slug: 'legal-notice',     title: 'Impressum' },
    { slug: 'privacy-policy',   title: 'Datenschutz' },
    { slug: 'terms-of-service', title: 'AGB' },
    { slug: 'shipping-policy',  title: 'Versand &amp; R&uuml;ckgabe' },
    { slug: 'refund-policy',    title: 'Widerruf' },
  ];

  var titleEl = container.querySelector('.shopify-policy__title');
  var bodyEl  = container.querySelector('.shopify-policy__body');

  var titleText = titleEl ? titleEl.textContent.trim() : '';
  var bodyHTML  = bodyEl  ? bodyEl.innerHTML : '';

  var activeIndex = navItems.findIndex(function (item) {
    return path === '/policies/' + item.slug;
  });

  var navHTML = navItems.map(function (item, i) {
    var num    = (i + 1 < 10 ? '0' : '') + (i + 1);
    var href   = '/policies/' + item.slug;
    var active = i === activeIndex ? ' is-active' : '';
    return '<li class="gb-rechtliches__nav-item' + active + '">' +
      '<a href="' + href + '" class="gb-rechtliches__nav-link">' +
      '<span class="gb-rechtliches__nav-num">' + num + '</span>' +
      '<span class="gb-rechtliches__nav-label">' + item.title + '</span>' +
      '</a></li>';
  }).join('');

  var eyebrow = activeIndex >= 0
    ? '<span class="gb-rechtliches__section-eyebrow">' +
        (activeIndex + 1 < 10 ? '0' : '') + (activeIndex + 1) +
        ' / ' + navItems[activeIndex].title + '</span>'
    : '';

  var main = document.getElementById('MainContent');
  if (!main) return;

  main.innerHTML =
    '<div class="gb-rechtliches">' +
      '<div class="gb-rechtliches__hero">' +
        '<div class="gb-rechtliches__hero-inner">' +
          '<nav class="gb-about__breadcrumb" aria-label="Breadcrumb">' +
            '<a href="/">Home</a>' +
            '<span aria-hidden="true">/</span>' +
            '<span>Rechtliches</span>' +
          '</nav>' +
          '<div class="gb-about__eyebrow gb-visible">' +
            '<span class="gb-about__eyebrow-line"></span>' +
            '<span class="gb-about__eyebrow-text">Das Kleingedruckte</span>' +
          '</div>' +
          '<h1 class="gb-rechtliches__h1">' +
            '<span class="gb-rechtliches__h1-line1">Recht &amp;</span>' +
            '<span class="gb-rechtliches__h1-line2">Ordnung</span>' +
          '</h1>' +
        '</div>' +
        '<span class="gb-rechtliches__hero-wm" aria-hidden="true">法</span>' +
      '</div>' +
      '<div class="gb-rechtliches__layout">' +
        '<aside class="gb-rechtliches__sidebar">' +
          '<nav class="gb-rechtliches__nav" aria-label="Rechtliches Navigation">' +
            '<p class="gb-rechtliches__nav-title">// Inhalt</p>' +
            '<ul class="gb-rechtliches__nav-list" role="list">' + navHTML + '</ul>' +
          '</nav>' +
          '<div class="gb-rechtliches__contact-box">' +
            '<p class="gb-rechtliches__contact-title">Fragen?</p>' +
            '<p class="gb-rechtliches__contact-text">Schreib uns — wir helfen schnell und unkompliziert weiter.</p>' +
            '<a href="/pages/contact" class="gb-rechtliches__contact-link">Kontakt aufnehmen →</a>' +
          '</div>' +
        '</aside>' +
        '<div class="gb-rechtliches__content">' +
          '<article class="gb-rechtliches__section">' +
            eyebrow +
            '<div class="gb-rechtliches__section-title-row">' +
              '<h1 class="gb-rechtliches__section-title">' + titleText + '</h1>' +
            '</div>' +
            '<hr class="gb-rechtliches__section-divider">' +
            '<div class="gb-prose">' + bodyHTML + '</div>' +
          '</article>' +
        '</div>' +
      '</div>' +
    '</div>';
})();
